<template>
  <button class="button mgr-10px has-text-default bouton-dropdown-entete-ecran"
    :disabled="isLoading "
    v-if="parametre">
    <b-dropdown position="is-bottom-left"  class="has-text-left height-21px" >
      <b-icon icon="cog" slot="trigger" role="button"  type="is-default">
      </b-icon>
      <b-dropdown-item custom aria-role="menuitem">
        <p class="has-text-weight-bold is-size-6">
          {{$t('general.parametrageTable.title')}}</p>
      </b-dropdown-item>
      <hr class="dropdown-divider">
      <b-dropdown-item
        aria-role="menu-item"
        :focusable="false"
        custom
        paddingless>
        <div class="modal-card width-200px">
          <section  class="mgh-10px mgb-10px">
            <b-field :label="$t('general.parametrageTable.nbreParPage')">
              <b-select expanded v-model="parametre.nbResultatParPage">
                <option
                  v-for="nbre in listesNbreResultatParPages"
                  :value="nbre"
                  :key="nbre">
                  {{ nbre }}
                </option>
              </b-select>
            </b-field>
          </section>
          <footer class="has-text-centered">
            <button class="button is-addOrEdit has-text-white" @click="sauvegarder">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </footer>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </button>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { changeSettingForUser } from '@/api/settings';
import genererParametreTable from '@/services/general/generer/genererParametreTable';
import messageErreur from '@/services/general/messageErreur';
import * as types from '@/store/modules/tableUserParam-mutation-type';
import { PER_PAGE_VALUE } from '@/configuration/clientTableConf';

const TableUserParam = createNamespacedHelpers('tableUserParam');

export default {
  props: {
    referenceTable: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      parametre: null,
      listesNbreResultatParPages: PER_PAGE_VALUE,
      sLoading: true,
    };
  },
  computed: {
    ...TableUserParam.mapGetters({
      tableUserParam: 'tableUserParam',
      paramForTab: 'paramForTab',
    }),
    parametreTable() {
      return this.paramForTab(this.referenceTable);
    },
  },
  methods: {
    ...TableUserParam.mapMutations({
      setTableUserParam: types.SET_TABLE_USER_PARAM,
    }),
    ...TableUserParam.mapActions({
      actionLoadTableUserParam: 'loadTableUserParam',
    }),
    async sauvegarder() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.miseAJourParametreTableau();
        const tableParam = cloneDeep(this.tableUserParam);
        tableParam[this.referenceTable] = this.parametre;
        await changeSettingForUser(types.TABLE_USER_PARAM_KEY, JSON.stringify(tableParam));
        this.setTableUserParam(tableParam);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    miseAJourParametreTableau() {
      if (!this.parametre || !this.parametre.nbResultatParPage) return;

      const referenceTable = this.$parent.$refs[this.referenceTable];
      if (!referenceTable) {
        this.$parent.resultPerPage = this.parametre.nbResultatParPage;
        return;
      }

      const componentParent = referenceTable.setLimit
        ? referenceTable : referenceTable.$refs[this.referenceTable];
      componentParent.setLimit(this.parametre.nbResultatParPage);

      const composantPagination = componentParent.$children[0].$children
        .find(child => child.constructor.extendOptions.name === 'TableItemsInView');

      if (composantPagination) {
        composantPagination.value = this.parametre.nbResultatParPage;
      }
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.actionLoadTableUserParam();
    this.parametre = this.parametreTable
      ? cloneDeep(this.parametreTable) : genererParametreTable();
    this.miseAJourParametreTableau();
    this.isLoading = false;
    this.$emit('endLoadParamtre');
  },
};
</script>

<style>

</style>
